import logo from './logo.svg';
import './App.css';
import '@livekit/components-styles';
import { Button, Navbar, Container, Nav, Image, Tab, Tabs, TabContainer } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Configure from './components/configure';
import Demo from './components/demo';
import Activities from './components/activities';
import { Routes, Route, BrowserRouter, Link, NavLink } from 'react-router-dom';
import Logo from './assets/allteam-logo-white.png';
import axios from 'axios';
import { useEffect, useState, createContext } from 'react';
import Voices from './voices.json'
import Avatars from './avatars.json'
import './style.css'
import Login from './components/login';

export const AppContext = createContext(null);

function App() {

  const [configData, setConfigData] = useState({});
  const [configList, setConfigList] = useState([]);
  const [configName, setConfigName] = useState(null);
  const [activeTab, setActiveTab] = useState("home");
  const [loading, setLoading] = useState('');
  const [isConfigurationLoading, setIsConfigurationLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  // const [isTest, setIsTest] = useState(false);

  const getConfiguration = async (id) => {
    //  setLoading('configuration-loading');
    setIsConfigurationLoading(true);
    try {
      const response = await axios.get(`/get_config/${id}`)
      const result = response.data[0];
      const avatar = getItem(Avatars, result.avatar)
      const voice = getItem(Voices, result.voice)
      const configData = {
        id: result.id,
        name: result.name,
        agentName: result.agent_name,
        instructions: result.instructions,
        firstMessage: result.first_message,
        avatar: avatar,
        voice: voice,
        uploaded_files: result.uploaded_files && result.uploaded_files.trim() ? result.uploaded_files.split(',').map(f => f.trim()) : []
      }
      setConfigName(configData.name);
      return configData;
    }
    catch (error) {
      console.error("Error fetching configuration:", error);
      return false;
    }
    finally {
      setIsConfigurationLoading(false);
    }
  }

  const getItem = (list, id) => list.find((item) => item.id === id);

  const getAllConfigurations = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/get_all_config`)
      const configurationList = response.data;
      if (configList)
        return configurationList
      else
        return [];
    }
    catch (error) {
      console.error("Error fetching all configurations:", error);
      return [];
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      const defaultConfig = await getConfiguration(6);
      setConfigData(defaultConfig);
      const configurationList = await getAllConfigurations();
      setConfigList(configurationList);
    }
    )();
  }, [])

  const handleConfigChange = async (e) => {
    //  setIsTest(false)
    const value = e.target.value;
    const configuration = await getConfiguration(value);
    setConfigData(configuration);
  }

  return (
    <AppContext.Provider value={{ configData, setConfigData, configList, setConfigList, getAllConfigurations, configName, setConfigName, handleConfigChange, getConfiguration, loading, setLoading }} >
      <div className="App h-full">
        {!isLogin && <Login setIsLogin={setIsLogin} />}
        {isLogin &&
          <BrowserRouter>
            <Navbar className='w-full' expand="lg" style={{ background: "linear-gradient(120deg, #50026dff, #d800a6ff)" }}>
              <Container className='mx-md-2 m-0'>
                <Navbar.Brand as={Link} to="/">
                  <Image src={Logo} alt="Logo" width={150} /><superscript className='position-absolute top-1/2 px-1' style={{ "color": "#f77b0b", "fontSize": "0.8rem" }}>BETA</superscript>
                </Navbar.Brand>
              </Container>
            </Navbar>
            <TabContainer activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
              <div className="d-flex align-items-center justify-content-between px-3 w-100 mt-3">
                <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="nav-tabs w-100 mb-0">
                  <Nav.Item>
                    <Nav.Link eventKey="home">Home</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="configure">Configure</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="activities">Activities</Nav.Link>
                  </Nav.Item>
                </Nav>

                <div className="ms-3 d-flex align-items-center">
                  <Button
                    variant="light"
                    title="Restart agents"
                    onClick={async () => {
                      setLoading('restarting-agents');
                      try {
                        const resp = await axios.post('/admin/restart_agents');
                        alert('Restart completed.');
                      }
                      catch (err) {
                        console.error(err);
                        alert('Failed to restart agents: ' + (err.response?.data?.detail || err.message));
                      }
                      finally {
                        setLoading('');
                      }
                    }}
                    disabled={loading === 'restarting-agents'}
                  >
                    <i className="bi bi-recycle" style={{ fontSize: '1.2rem' }}></i>
                  </Button>
                </div>
              </div>

              <Tab.Content className="px-md-3 mt-2">
                <Tab.Pane eventKey="home">
                  <Demo isConfigurationLoading={isConfigurationLoading} />
                </Tab.Pane>
                <Tab.Pane eventKey="configure">
                  <Configure goToDemo={() => setActiveTab("home")} />
                </Tab.Pane>
                <Tab.Pane eventKey="activities">
                  <Activities activeTab={activeTab} />
                </Tab.Pane>
              </Tab.Content>
            </TabContainer>
          </BrowserRouter>}
      </div>
    </AppContext.Provider>
  );
}

export default App;
